import React from "react";
import { Modal, Button } from "react-bootstrap";

const AlertModal = ({
  show = false,
  onHide = () => {},
  title = "Confirmation",
  message = "Are you sure?",
  type = "confirm", // 'confirm', 'alert', 'success', 'error', 'warning'
  confirmText = "Confirm",
  cancelText = "Cancel",
  onConfirm = () => {},
  onCancel = () => {},
  size = "md", // 'sm', 'md', 'lg', 'xl'
  centered = true,
  showCancelButton = true,
  confirmVariant = "primary",
  cancelVariant = "secondary",
  icon = null,
  children = null, // For custom content
}) => {
  const handleClose = () => {
    onHide();
    if (onCancel) onCancel();
  };

  const handleConfirm = () => {
    onConfirm();
    onHide();
  };

  // Define variants based on type
  const getVariantByType = (type) => {
    switch (type) {
      case "success":
        return "success";
      case "error":
      case "danger":
        return "danger";
      case "warning":
        return "warning";
      case "info":
        return "info";
      case "confirm":
      default:
        return "primary";
    }
  };

  // Define icons based on type
  const getIconByType = (type) => {
    switch (type) {
      case "success":
        return "✅";
      case "error":
      case "danger":
        return "❌";
      case "warning":
        return "⚠️";
      case "info":
        return "ℹ️";
      case "confirm":
        return "❓";
      default:
        return null;
    }
  };

  const defaultIcon = icon || getIconByType(type);
  const defaultConfirmVariant = confirmVariant !== "primary" ? confirmVariant : getVariantByType(type);

  return (
    <Modal 
      show={show} 
      onHide={handleClose} 
      centered={centered} 
      size={size}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton>
        <Modal.Title className="d-flex align-items-center">
          {/* {defaultIcon && (
            <span className="me-2" style={{ fontSize: "1.2em" }}>
              {defaultIcon}
            </span>
          )} */}
          {title}
        </Modal.Title>
      </Modal.Header>
      
      <Modal.Body>
        {children ? (
          children
        ) : (
          <div className="text-center">
            <p className="mb-0" style={{ fontSize: "16px", lineHeight: "1.5" }}>
              {message}
            </p>
          </div>
        )}
      </Modal.Body>
      
      <Modal.Footer className="justify-content-center">
        {showCancelButton && (
          <Button 
            variant={cancelVariant} 
            onClick={handleClose}
            style={{ minWidth: "100px" }}
          >
            {cancelText}
          </Button>
        )}
        <Button 
          variant={defaultConfirmVariant} 
          onClick={handleConfirm}
          style={{ minWidth: "100px" }}
        >
          {confirmText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AlertModal;